import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Document = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M16 22H9C4 22 3 20 3 16V10C3 5.44 4.67 4.2 8 4.02M16 4.02C19.33 4.2 21 5.43 21 10V16C21 20.57 19.33 21.8 16 21.98M16.25 11.95H7.75M16.25 15.95H7.75M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
